import { render, staticRenderFns } from "./SegmentedMultiposition.vue?vue&type=template&id=4f014504&scoped=true"
import script from "./SegmentedMultiposition.vue?vue&type=script&lang=ts"
export * from "./SegmentedMultiposition.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedMultiposition.vue?vue&type=style&index=0&id=4f014504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f014504",
  null
  
)

export default component.exports